import { z } from "zod";
import { expectedVersion, id, pageInput } from "./common";
import { longText } from "./text";
import { VISIBILITIES } from "./visibility";

/** What a comment can be about. */
export const COMMENT_TARGETS = ["campaign", "brief_revision", "task", "idea", "decision"] as const;
export type CommentTarget = (typeof COMMENT_TARGETS)[number];

/** A change request is a comment that has to be dealt with, not just read. */
export const COMMENT_KINDS = ["comment", "change_request"] as const;
export type CommentKind = (typeof COMMENT_KINDS)[number];

export const CHANGE_REQUEST_STATUSES = ["open", "resolved"] as const;
export type ChangeRequestStatus = (typeof CHANGE_REQUEST_STATUSES)[number];

const commentBody = longText(4000).min(1, "Write something first");
const unique = (items: readonly string[]) => new Set(items).size === items.length;

export const createCommentInput = z.object({
  campaignId: id,
  targetType: z.enum(COMMENT_TARGETS),
  targetId: id,
  body: commentBody,
  visibility: z.enum(VISIBILITIES),
  kind: z.enum(COMMENT_KINDS),
  mentionUserIds: z.array(id).max(20).refine(unique, "Each person only once"),
});
export type CreateCommentInput = z.infer<typeof createCommentInput>;

export const editCommentInput = z.object({ commentId: id, body: commentBody, expectedVersion });
export const commentActionInput = z.object({ commentId: id, expectedVersion });
export const resolveChangeRequestInput = commentActionInput.extend({
  note: longText(2000).optional(),
});

export const listCommentsInput = pageInput.extend({
  campaignId: id,
  targetType: z.enum(COMMENT_TARGETS).optional(),
  targetId: id.optional(),
});
export type ListCommentsInput = z.infer<typeof listCommentsInput>;
